module.exports = __webpack_public_path__ + "img/top.0f749c36.png";